import React from "react";

import { BriefLoader } from "../../../../../../../../components/brief/BriefLoader";
import { Header } from "../../../../../../../../components/headers/header/header.component";
import { PAGES } from "../../../../../../../../features/navigation/types/pages.constant";

import { FlyerDetailAddPageTemplateSelector } from "../flyer-detail-add-page-template-selector/flyer-detail-add-page-template-selector.component";

import { FlyerDetailAddPageViewProps } from "./flyer-detail-add-page-view.props";
import { HostContainer } from "./flyer-detail-add-page-view.styles";

export const FlyerDetailAddPageView = (props: FlyerDetailAddPageViewProps) => {
  return (
    <HostContainer>
      <Header
        parentTitle={`${PAGES.FLYERS.TITLE} - ${PAGES.FLYER_PAGES_ADD.TITLE} - `}
        title="Select Template"
        showBackButton={true}
        customGoBack={props.onBack}
      />
      <div>
        <BriefLoader showIf={props.isLoading} />
        <FlyerDetailAddPageTemplateSelector
          showIf={!props.isLoading && Boolean(props.templates)}
          templates={props.templates!}
          onSubmit={props.onSubmit}
        />
      </div>
    </HostContainer>
  );
};
